var _rect, _path, _path2, _path3, _path4, _path5, _path6, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgConfetti(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 79,
    height: 79,
    viewBox: "0 0 79 79",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 79,
    height: 79,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M48.7684 2.78418C49.0954 4.69744 49.4706 6.56066 49.5839 8.49792C49.6649 9.8838 49.6749 11.8226 49.315 13.7661C48.8946 16.0363 47.8415 18.0791 47.0066 19.4483C45.903 21.2582 44.5576 22.7628 43.1983 24.387L38.1498 20.1617C40.0371 17.9068 42.2843 15.5778 42.8417 12.5674C43.3879 9.6181 42.7729 6.78169 42.2791 3.89342L48.7684 2.78418Z",
    fill: "url(#paint0_linear_1_5637)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M65.9258 9.53877L62.2147 19.8475L56.0205 17.6176L59.7317 7.30887L65.9258 9.53877Z",
    fill: "url(#paint1_linear_1_5637)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M58.9627 24.6876L51.0159 32.6344L46.3608 27.9792L54.3075 20.0325L58.9627 24.6876Z",
    fill: "url(#paint2_linear_1_5637)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M73.5363 26.1597L64.3563 30.7496L61.4121 24.8613L70.5921 20.2713L73.5363 26.1597Z",
    fill: "url(#paint3_linear_1_5637)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M56.0953 32.7807C59.2304 32.9132 62.1273 32.9834 65.1858 33.9621C68.2437 34.9406 70.9488 36.761 73.6532 38.4416L70.1786 44.0333C67.9791 42.6665 65.6623 41.0268 63.1793 40.2322C60.7555 39.4566 58.3261 39.4642 55.8173 39.3582L56.0953 32.7807Z",
    fill: "url(#paint4_linear_1_5637)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M24.8934 13.6563L65.3422 54.1051L6.58325 72.0681L24.8934 13.6563Z",
    fill: "url(#paint5_linear_1_5637)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1_5637",
    x1: 6.58325,
    y1: 2.78418,
    x2: 75.8306,
    y2: 69.8188,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FC6C29"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FC6C29"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1_5637",
    x1: 6.58325,
    y1: 2.78418,
    x2: 75.8306,
    y2: 69.8188,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FC6C29"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FC6C29"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1_5637",
    x1: 6.58325,
    y1: 2.78418,
    x2: 75.8306,
    y2: 69.8188,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FC6C29"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FC6C29"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_1_5637",
    x1: 6.58325,
    y1: 2.78418,
    x2: 75.8306,
    y2: 69.8188,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FC6C29"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FC6C29"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_1_5637",
    x1: 6.58325,
    y1: 2.78418,
    x2: 75.8306,
    y2: 69.8188,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FC6C29"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FC6C29"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_1_5637",
    x1: 6.58325,
    y1: 2.78418,
    x2: 75.8306,
    y2: 69.8188,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FC6C29"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FC6C29"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgConfetti);
export default __webpack_public_path__ + "static/media/confetti.cbfa012c57a3515f14fbc693d32d5842.svg";
export { ForwardRef as ReactComponent };